<template>
  <div class="app-cookie-bar cookie-bar">
    <transition name="fade">
      <div v-if="!inApp && show" class="cookie-bar__wrapper">
        <a :href="`/cookie/${lang}.html`">{{$translate('COOKIES')}}</a>
        <a :href="`https://www.gucci.com/documents/legal/privacy/${lang}.pdf`" target="_blank" rel="noopener">{{$translate('PRIVACY')}}</a>
      </div>
    </transition>
  </div>
</template>

<script>
import { getLang, inApp } from '../scripts/utils';

export default {
  name: 'AppCookieBar',

  data() {
    return {
      show: true,
      lang: getLang(),
      inApp: inApp(),
    };
  },
};
</script>

<style lang="scss" scoped>
.cookie-bar {
  &__wrapper {
    position: fixed;
    bottom: $unit-vh;
    left: 50%;

    transform: translateX(-50%);
    font-size: 10px;

    @include mq($until: ipadL) {
      bottom: 20px;
      font-size: 12px;
    }

    @include mq($until: mobileX) {
      bottom: 10px;
    }
  }
}
</style>
